/* @flow */
import React from 'react';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal.jsx';
import Teacher from 'entities/Teacher';
import UserActions from 'user/UserActions';

class ReportTeacherSelectModal extends React.Component {
  static propTypes = {
    teacher: React.PropTypes.instanceOf(Teacher).isRequired,
    onRequestHide: React.PropTypes.func,
  };

  reportTeacher = (reason: string, notes: string) => {
    UserActions.reportUser(this.props.teacher.id, reason, notes);
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  render() {
    const options = [
      'This person doesn’t teach at this school',
      'Inappropriate behavior',
    ];

    return (
      <ReportToRemindSelectModal
        {...this.props}
        options={options}
        reportee={this.props.teacher.getName()}
        notesPlaceholder="Why are you reporting this Teacher?"
        onReport={this.reportTeacher}
      />
    );
  }
}

export default ReportTeacherSelectModal;



// WEBPACK FOOTER //
// ./src/support/components/ReportTeacherSelectModal.jsx